export default {
  "fontElementMap": "_0Bj-r",
  "link": "Be0di",
  "linkInEditor": "WcYwj",
  "linkInViewer": "_89jR0",
  "toolbarUrlContainer": "gy5da",
  "toolbarUrl": "pXIbj",
  "toolbarUrlAnchor": "a4-pA"
};